/* The Saved page (main-saved.liquid, 2026-09-27): draws a card for every saved handle, newest first. */
(() => {
  const grid = document.querySelector('[data-saved-grid]');
  if (!grid) return;
  const empty = document.querySelector('[data-saved-empty]');
  const note = document.querySelector('[data-saved-note]');
  let list = [];
  try { list = JSON.parse(localStorage.getItem('melanin:saved') || '[]'); } catch { list = []; }
  list = list.reverse();
  const state = () => { const n = grid.children.length; empty.hidden = n > 0; note.hidden = n === 0; };
  if (!list.length) { state(); return; }
  Promise.all(list.map((h) => fetch(`/products/${encodeURIComponent(h)}?view=card`).then((r) => (r.ok ? r.text() : '')).catch(() => '')))
    .then((htmls) => {
      grid.innerHTML = htmls.filter((x) => x.includes('class="card"')).join('');
      state();
      document.dispatchEvent(new CustomEvent('melanin:cards-added'));
    });
  /* Un-hearting a work here takes it off the page. */
  document.addEventListener('melanin:saved', (e) => {
    if (e.detail.saved) return;
    const b = grid.querySelector(`[data-save="${CSS.escape(e.detail.handle)}"]`);
    const card = b && b.closest('.card');
    if (card) { card.remove(); state(); }
  });
})();
